import { Navigate, useParams } from "react-router-dom";
import { FaBookOpen } from "react-icons/fa";
import { CoursesViewMain } from "../Components/CoursesViewMain";
import { CourseDetailViewMain } from "../Components/CourseDetailViewMain";

const CourseDefaultRoute = () => {
    const { id } = useParams();
    return <Navigate to={`/courses/${id}/notebook`} replace />;
};

export const CoursesModule = () => [
    {
        views: "PRIVATE", path: "/courses/:id/:tab", component: <CourseDetailViewMain />,
        roles: null, permissions: null, label: "Detalle de curso", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false, isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/courses/:id", component: <CourseDefaultRoute />,
        roles: null, permissions: null, label: "Detalle de curso", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false, isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/courses", component: <CoursesViewMain />,
        roles: null, permissions: null, label: "Cursos", icon: <FaBookOpen />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true, isBlockedWhenLogged: false,
    },
];
